<clx-row type="buttons">
    <clx-button
        (click)="activate()"
        i18n="@@administration.pre-register.button"
        test-id="administration.preregister.button.activatemultipleplants"
    >Pre-register multiple plants</clx-button>
</clx-row>
<clx-form>
    <h3 i18n="@@administration.pre-register.title">Pre-register multiple plants</h3>
    <clx-row>
        <clx-label i18n="@@administration.pre-register.label">Activation keys (commas seperated or one per line)</clx-label>
        <clx-textarea
            [(ngModel)]="activationKeys"
            name="activationKeys"
            test-id="administration.preregister.text.activationkeys"
        ></clx-textarea>
    </clx-row>
</clx-form>